'use client';

const STEPS = [
  'Entreprise',
  'Domaine',
  'Coordonnées',
  'Emails',
  'Récapitulatif',
  'Confirmation',
  'Paiement',
];

interface StepIndicatorProps {
  currentStep: number; // 2-8 (step 1 is landing, step 9 is confirmation)
}

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  const index = currentStep - 2; // map step 2→0, step 3→1, etc.

  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between max-w-xl mx-auto">
        {STEPS.map((label, i) => {
          const isActive = i === index;
          const isDone = i < index;

          return (
            <div key={label} className="flex flex-col items-center flex-1">
              <div className="flex items-center w-full">
                {i > 0 && (
                  <div
                    className={`h-0.5 flex-1 transition-colors duration-300 ${
                      isDone ? 'bg-primary' : 'bg-border'
                    }`}
                  />
                )}
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 shrink-0 ${
                    isDone
                      ? 'bg-primary text-white'
                      : isActive
                        ? 'bg-primary text-white ring-4 ring-primary-light'
                        : 'bg-border text-muted'
                  }`}
                >
                  {isDone ? '✓' : i + 1}
                </div>
                {i < STEPS.length - 1 && (
                  <div
                    className={`h-0.5 flex-1 transition-colors duration-300 ${
                      isDone ? 'bg-primary' : 'bg-border'
                    }`}
                  />
                )}
              </div>
              <span
                className={`text-xs mt-1.5 text-center hidden sm:block ${
                  isActive ? 'text-primary font-semibold' : 'text-muted'
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}